import { render, staticRenderFns } from "./PatientSearchPopover.vue?vue&type=template&id=051c067a&"
import script from "./PatientSearchPopover.vue?vue&type=script&lang=ts&"
export * from "./PatientSearchPopover.vue?vue&type=script&lang=ts&"
import style0 from "./PatientSearchPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports